import { ReactNode } from "react";
import { Redirect } from "wouter";
import { useRequireAuth, UserRole } from "@/hooks/useAuth";
import { Loader2 } from "lucide-react";

interface RouteGuardProps {
  children: ReactNode;
  allowedRoles?: UserRole[];
  loginRedirect?: string;
}

const ROLE_HOME: Record<UserRole, string> = {
  ADMIN: "/mother",
  RECRUITMENT_AGENT: "/agent/dashboard",
  CANDIDATE: "/login",
};

export function RouteGuard({ children, allowedRoles, loginRedirect = "/login" }: RouteGuardProps) {
  const { isLoading, isAuthenticated, user } = useRequireAuth(allowedRoles);

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <div className="text-center">
          <Loader2 className="w-8 h-8 animate-spin text-primary mx-auto mb-4" />
          <p className="text-muted-foreground">Loading...</p>
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    if (loginRedirect === "/login") {
      const currentPath = window.location.pathname + window.location.search;
      return <Redirect to={`/login?returnTo=${encodeURIComponent(currentPath)}`} />;
    }
    return <Redirect to={loginRedirect} />;
  }

  if (allowedRoles && user && !allowedRoles.includes(user.role)) {
    return <Redirect to={ROLE_HOME[user.role] ?? loginRedirect} />;
  }

  return <>{children}</>;
}
